import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { lastValueFrom } from 'rxjs'
import { ConnecterProduct } from 'src/api/actuates-api/actuates-api.interface'
import { ActuatesService } from 'src/api/actuates-api/actuates-api.service'
import { BackendOrganizationV2 } from 'src/api/organizationsV2-api/organizationV2-api.model'
import { messageList } from 'src/app/components/message/message-data'
import { MessageService } from 'src/app/components/message/message.service'
import { ServiceMapViewService } from 'src/app/module/myidea-parts/service-map-view.service'

@Component({
  selector: 'app-ura-conector-link',
  templateUrl: './ura-conector-link.component.html',
  styleUrls: ['./ura-conector-link.component.scss']
})
export class UraConactorLinkComponent implements OnInit {
  @Input() productCd: string // 接続元(自分)の製品CD
  @Input() actuateCd: string // 紐づけ元のactuateCd
  @Output() selectTarget = new EventEmitter<string>() // 対象actuateCd
  targetProductCd = ''
  targetProductName = ''
  targetProductOptions: { productCd: string, productName: string }[] = []
  targetOrganizationCd: string
  allProductList: ConnecterProduct[] = []
  selectedProductList: ConnecterProduct[] = []
  productViewFlag = false
  noProductFound = false
  selectedToActuatedCd: string

  constructor(
    private messageService: MessageService,
    private serviceMapViewService: ServiceMapViewService,
    private actuatesService: ActuatesService
  ) { }

  async ngOnInit(): Promise<void> {
    // 接続対象の製品候補を全件収集する
    const rules = this.serviceMapViewService.ActuateRelationRules
    const optionMap = new Map<string, string>()
    rules.filter(x => x.toProductCd === this.productCd).forEach(r => {
      optionMap.set(r.fromProductCd, r.fromProductName)
    })
    rules.filter(x => x.fromProductCd === this.productCd).forEach(r => {
      optionMap.set(r.toProductCd, r.toProductName)
    })
    this.targetProductOptions = Array.from(optionMap.entries()).map(([productCd, productName]) => ({ productCd, productName }))

    // 候補が1件のみの場合は自動セット（従来動作）
    if (this.targetProductOptions.length === 1) {
      this.targetProductCd = this.targetProductOptions[0].productCd
      this.targetProductName = this.targetProductOptions[0].productName
    }
  }

  onTargetProductChange(): void {
    const opt = this.targetProductOptions.find(x => x.productCd === this.targetProductCd)
    this.targetProductName = opt?.productName ?? ''
    this.selectedToActuatedCd = ''
    this.allProductList = []
    this.selectedProductList = []
    this.productViewFlag = false
    this.noProductFound = false
    // 会社選択済みの場合は新しいプロダクト種別でAPI再取得
    if (this.targetOrganizationCd) {
      this.updateTargetCompany({ organizationCd: this.targetOrganizationCd } as BackendOrganizationV2)
    }
  }

  async updateTargetCompany(company: BackendOrganizationV2): Promise<void> {
    this.targetOrganizationCd = company?.organizationCd

    if (!this.targetOrganizationCd) { return }
    const ret$ = this.actuatesService.GetConnecterProducts(this.actuateCd, this.targetProductCd, this.targetOrganizationCd)
    let ret = await lastValueFrom(ret$)

    if (ret?.resultCode !== 0) { return }
    this.allProductList = ret.data
    this.updateFilteredList()
  }

  private updateFilteredList(): void {
    // プロダクト種別が複数で未選択の場合は判定しない
    const productSelected = this.targetProductOptions.length <= 1 || !!this.targetProductCd
    this.selectedProductList = this.targetProductCd
      ? this.allProductList.filter(x => x.productCd === this.targetProductCd)
      : this.allProductList
    if (this.selectedProductList.length === 0) {
      this.productViewFlag = false
      this.noProductFound = !!(this.targetOrganizationCd && productSelected)
    } else {
      this.productViewFlag = true
      this.noProductFound = false
    }
  }

  conectActuates(): string {
    if (!this.targetOrganizationCd) {
      this.messageService.warning(`接続対象の会社が未選択です`)
      return null
    }
    if (!this.selectedToActuatedCd) {
      this.messageService.templeteMessage(messageList.M00034)
      return null
    }
    return this.selectedToActuatedCd
  }
}
